import { useSyncExternalStore } from "react"

import { MotionConfig } from "framer-motion"

import { ReducedMotionContext } from "@/shared/lib/reduced-motion"
import { useTelegramCloudStorage } from "@/shared/telegram/hooks"

const subscribe = (callback: () => void) => {
  const mql = window.matchMedia("(prefers-reduced-motion: reduce)")
  mql.addEventListener("change", callback)
  return () => {
    mql.removeEventListener("change", callback)
  }
}

const getSnapshot = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches

export const ReducedMotionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const osReducedMotion = useSyncExternalStore(subscribe, getSnapshot, () => false)
  const { value: userReducedMotion } = useTelegramCloudStorage<boolean>({
    key: "reduced_motion",
    defaultValue: false
  })

  const isReducedMotion = userReducedMotion || osReducedMotion

  return (
    <ReducedMotionContext value={isReducedMotion}>
      <MotionConfig reducedMotion={isReducedMotion ? "always" : "never"}>{children}</MotionConfig>
    </ReducedMotionContext>
  )
}
